<template>
	
	<v-container fluid class="pt-6 pb-0 px-1">

		<v-row>
			<v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6" class="px-3 pb-0 pt-0">
				<v-card width="100%" height="280" class="elevation-0 pl-4 pt-4" color="brighterBackground">
					<div class="font-weight-medium pb-4">Navigation</div>
					<v-row class="pl-6">
					
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								class="pt-0 mt-0"
								label="Breadcrumb member"
								v-model="docData.settings.breadcrumbMember"
							></v-checkbox>
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								cols="12" xs="12" sm="12" md="3"
								class="pt-0 mt-0"
								label="Overridable"
								v-model="docData.settings.breadcrumbMemberOverridable"
							></v-checkbox>
						</v-col>
					
						<v-col cols="12" xs="12" sm="12" md="12" class="py-0">
							<v-checkbox
								class="pt-0 mt-0"
								label="Expose editable breadcrumb for editors"
								:disabled="!(docData.settings.breadcrumbMember && docData.settings.breadcrumbMemberOverridable)"
								v-model="docData.settings.exposeEditableBreadcrumb"
							></v-checkbox>
						</v-col>
					
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								class="pt-0 mt-0"
								label="Main menu member"
								v-model="docData.settings.mainMenuMember"
							></v-checkbox>
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								cols="12" xs="12" sm="12" md="3"
								class="pt-0 mt-0"
								label="Overridable"
								v-model="docData.settings.mainMenuMemberOverridable"
							></v-checkbox>
						</v-col>
					
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								class="pt-0 mt-0"
								label="Sub menu member"
								v-model="docData.settings.subMenuMember"
							></v-checkbox>
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								cols="12" xs="12" sm="12" md="3"
								class="pt-0 mt-0"
								label="Overridable"
								v-model="docData.settings.subMenuMemberOverridable"
							></v-checkbox>
						</v-col>
					
					</v-row>
				</v-card>
			</v-col>
			<v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6" class="px-3 pb-0 pt-0">
				<v-card width="100%" height="280" class="elevation-0 pl-4 pt-4" color="brighterBackground">
					<div class="font-weight-medium pb-4">Icons</div>
					<v-row class="pl-6">
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-text-field
								label="Icon in editor"
								v-model="docData.settings.iconEditor"
								outlined
								dense
							></v-text-field>
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								class="pt-2 mt-0"
								label="Use same in front end"
								v-model="docData.settings.useSameIconsAsInEditorInFrontEnd"
							></v-checkbox>
						</v-col>

						<v-col cols="12" xs="12" sm="12" md="12" class="py-0">
							<v-checkbox
								class="pt-2 mt-0"
								label="Enable icons in front end"
								v-model="docData.settings.useIconsInFrontEnd"
							></v-checkbox>
						</v-col>
					
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-text-field
								label="Icon in front end"
								v-model="docData.settings.iconFrontEnd"
								outlined
								:disabled="docData.settings.useSameIconsAsInEditorInFrontEnd || !docData.settings.useIconsInFrontEnd"
								dense
							></v-text-field>
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								class="pt-2 mt-0"
								label="Overridable"
								:disabled="!docData.settings.useIconsInFrontEnd"
								v-model="docData.settings.iconFrontEndOverridable"
							></v-checkbox>
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="12" class="py-0">
							<v-checkbox
								class="pt-0 mt-n3"
								label="Expose editable icon for editors"
								v-model="docData.settings.exposeIconFrontEndToEditor"
								:disabled="!docData.settings.useIconsInFrontEnd"
							></v-checkbox>
						</v-col>
					
					</v-row>
				</v-card>
			</v-col>
		</v-row>
		

		<v-row class="pt-6 pb-4">
			<v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6" class="ml-0 pb-0 pt-0">
				<v-card width="100%" height="200" class="elevation-0 pl-4 pt-4" color="brighterBackground">
					<div class="font-weight-medium pb-4">Search</div>
					<v-row class="pl-6">
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								class="pt-0 mt-0"
								label="Show in search"
								v-model="docData.settings.showInSearch"
							></v-checkbox>
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								cols="12" xs="12" sm="12" md="3"
								class="pt-0 mt-0"
								label="Overridable"
								v-model="docData.settings.showInSearchOverridable"
							></v-checkbox>
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								class="pt-0 mt-0"
								label="Enable SEO for this view"
								v-model="docData.settings.enableSeo"
							></v-checkbox>
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								cols="12" xs="12" sm="12" md="3"
								class="pt-0 mt-0"
								label="Overridable"
								v-model="docData.settings.enableSeoOverridable"
							></v-checkbox>
						</v-col>
					</v-row>
				</v-card>
			</v-col>
		



			<v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6" class="px-3 pb-0 pt-0">
				<v-card width="100%" height="200" class="elevation-0 pl-4 pt-4" color="brighterBackground">
					<div class="font-weight-medium pb-4">Visual</div>
					<v-row class="pl-6">
					
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							
							<v-select
								v-model="docData.settings.preloadFlow"
								:items="preloadFlowItems"
								item-text="name"
								item-value="keyWord"
								label="Preload flow"
								outlined
								dense
							></v-select>
						
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								cols="12" xs="12" sm="12" md="3"
								class="pt-2 mt-0"
								label="Overridable"
								v-model="docData.settings.preloadFlowOverridable"
							></v-checkbox>
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-select
								v-model="docData.settings.depth"
								:items="depthItems"
								item-text="name"
								item-value="keyWord"
								label="Depth"
								outlined
								dense
							></v-select>
						</v-col>
						<v-col cols="12" xs="12" sm="12" md="6" class="py-0">
							<v-checkbox
								cols="12" xs="12" sm="12" md="3"
								class="pt-2 mt-0"
								label="Overridable"
								v-model="docData.settings.depthOverridable"
							></v-checkbox>
						</v-col>
					
					</v-row>
				</v-card>
			</v-col>  
		</v-row>
		

	
	</v-container>

</template>


<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

//import agile from "@/shift/agile";
//import fb from '@/shift/fb';
//import ViewsSystemSettingsVO from "@/valueobjects/ViewsSystemSettingsVO";


export default
{
    name: 'ViewsEditorSettings',

	props:
	{
		id: { type: String },
		docData: { type: Object },
	},
	
    data: () =>
    ({
		preloadFlow: null,
		
		preloadFlowItems:
		[
			{
				name: 'Preload after last page transitions out',
				keyWord: 'preloadAfterLastTransitionOut',
			},
			{
				name: 'Preload before last page transitions out',
				keyWord: 'preloadBeforeLastTransitionOut',
			},
		],

		depth: null,
		
		depthItems:
		[
			{
				name: 'Default',
				keyWord: 'default',
			},
			{
				name: 'Nested',
				keyWord: 'nested',
			},
			{
				name: 'Background',
				keyWord: 'background',
			},
			{
				name: 'Middle',
				keyWord: 'middle',
			},
			{
				name: 'Top',
				keyWord: 'top',
			},
			{
				name: 'Popup',
				keyWord: 'popup',
			},
			{
				name: 'Topmost',
				keyWord: 'topmost',
			},
		],
    }),



    computed:
	{
        /* agile()
        {
            return agile;
		},
		
		routeKey()
		{
			return this.$route.params.key;
		}, */
	},



	created()
	{
		//fb;
	},

    mounted()
    {
        
		
    },

    methods:
    {
		
    }

}

</script>
